import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_FollowUpNursingAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_FollowUpNursingAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h3>
                    Nursing Assessment Follow Up
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Client Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Client DOB:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Parent/Guardian Name: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtClientDob' name='txtClientDob' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtParent' name='txtParent' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Insurance #: </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Nurse Name and Credentials:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Code:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNurseName' name='txtNurseName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtServiceCode' name='txtServiceCode' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Service:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Location: </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Start Time:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateService' name='txtInsurance' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLocation' name='txtLocation' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='time' id='txtStartTime' name='txtStartTime' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>End Time:</span>
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtEndTime' name='txtEndTime' className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h4>
                    Relevant Medical Conditions
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Current Health Issues: </span>
                    <input type='checkbox' id='rbCurrentHealth_1' name='rbCurrentHealth_1' className='add-only' value='CurrentHealth_1' /> Denied
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Significant Injuries: </span>
                    <input type='checkbox' id='rbSignificant_1' name='rbSignificant_1' className='add-only' value='Significant_1' /> Denied
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies: </span>
                    <input type='checkbox' id='rbAllergies_1' name='rbAllergies_1' className='add-only' value='Allergies_1' /> Denied
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Type of Allergy</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>List of Allergens </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Reaction</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbFood_1' name='rbFood_1' className='add-only' value='Food_1' />
                            Food:
                            <input type='text' id='txtFood_1' name='txtFood_1' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAllergens_1' name='txtAllergens_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtReaction_1' name='txtReaction_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbFood_2' name='rbFood_2' className='add-only' value='Food_2' />
                            Contact: <input type='text' id='txtFood_2' name='txtFood_2' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAllergens_2' name='txtAllergens_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtReaction_2' name='txtReaction_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbFood_3' name='rbFood_3' className='add-only' value='Food_' />
                            Environmental: <input type='text' id='txtFood_3' name='txtFood_3' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAllergens_3' name='txtAllergens_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtReaction_3' name='txtReaction_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbFood_4' name='rbFood_4' className='add-only' value='Food_4' />
                            Drug: <input type='text' id='txtFood_4' name='txtFood_4' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAllergens_4' name='txtAllergens_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtReaction_4' name='txtReaction_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Alcohol/Substance/Tobacco Use: </span>
                    <input type='checkbox' id='rbAlcohol_1' name='rbAlcohol_1' className='add-only' value='Alcohol_1' /> Denied
                    <textarea id='txtAlcoholUse' name='txtAlcoholUse' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Type</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency </span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date of Last Use</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            Alcohol  <input type='text' id='txtAlcohol_1' name='txtAlcohol_1' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtLastUse_1' name='txtLastUse_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            Drug/Substance:  <input type='text' id='txtAlcohol_2' name='txtAlcohol_2' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtLastUse_2' name='txtLastUse_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            Tobacco:  <input type='text' id='txtAlcohol_3' name='txtAlcohol_3' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='date' id='txtLastUse_3' name='txtLastUse_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Medications </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbMedications_1' name='rbMedications_1' className='add-only' value='Medications_1' /> Denied
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbMedications_2' name='rbMedications_2' className='add-only' value='Medications_2' /> Compliant with medications
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbMedications_3' name='rbMedications_3' className='add-only' value='Medications_3' /> Non-compliant with medications
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Medication Name </span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Dose/Frequency</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Prescribed by?</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>When? </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Next refill? </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Side Effects</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDoseFrequency_1' name='txtDoseFrequency_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribed_1' name='txtPrescribed_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhen_1' name='txtWhen_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtNextRefill_1' name='txtNextRefill_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSideEffects_1' name='txtSideEffects_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDoseFrequency_2' name='txtDoseFrequency_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribed_2' name='txtPrescribed_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhen_2' name='txtWhen_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtNextRefill_2' name='txtNextRefill_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSideEffects_2' name='txtSideEffects_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDoseFrequency_3' name='txtDoseFrequency_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribed_3' name='txtPrescribed_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhen_3' name='txtWhen_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtNextRefill_3' name='txtNextRefill_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSideEffects_3' name='txtSideEffects_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='text' id='txtMedicationName_4' name='txtMedicationName_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDoseFrequency_4' name='txtDoseFrequency_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribed_4' name='txtPrescribed_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhen_4' name='txtWhen_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtNextRefill_4' name='txtNextRefill_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSideEffects_4' name='txtSideEffects_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    Dental Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Date of Last Dental Visit: </span>
                    <input type='date' id='txtDateLast' name='txtDateLast' className='add-only' />
                    <input type='checkbox' id='rbDateLast_1' name='rbDateLast_1' className='add-only' value='DateLast_1' /> Unable to recall
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rate Oral Hygiene: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="radio" id="rb_2_1" name="rb_2" className='add-only' value="1" /> Good
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rb_2_2" name="rb_2" className='add-only' value="2" /> Fair
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rb_2_3" name="rb_2" className='add-only' value="3" /> Poor
                        </td>
                        <td className='w-300'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="radio" id="rb_2_4" name="rb_2" className='add-only' value="4" /> Other:
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-300'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only' />
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-300'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How many times a day does the individual brush their teeth?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_3_1" name="rb_3" className='add-only' value="1" /> 0
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_3_2" name="rb_3" className='add-only' value="2" /> 1
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_3_3" name="rb_3" className='add-only' value="3" /> 2
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_3_4" name="rb_3" className='add-only' value="4" /> 3
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_3_5" name="rb_3" className='add-only' value="5" /> Other:
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtOtherR' name='txtOtherR' className='add-only' />
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Detail Complaints/Needs: </span>
                    <input type='checkbox' id='cbComplaints_1' name='cbComplaints_1' className='add-only' value='Complaints_1' /> Denied
                    <textarea id='txtComplaints' name='txtComplaints' className='add-only'></textarea>
                </p>
                <h4>
                    Vision Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual wear corrective lenses ?</span>
                    <span className='small'>(i.e., glasses, contacts)</span>
                    <input type="radio" id="rbGlasses_1_Yes" name="rbGlasses_1" className='add-only' value="1" /> Denied     &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_1_No" name="rbGlasses_1" className='add-only' value="0" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual wear corrective lenses ?</span>
                    <span className='small'>(i.e., glasses, contacts)</span>
                    <input type="radio" id="rbGlasses_2_Yes" name="rbGlasses_2" className='add-only' value="1" /> No    &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_2_No" name="rbGlasses_2" className='add-only' value="0" /> Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional comments:</span>
                    <input type='checkbox' id='cbComplaints_2' name='cbComplaints_2' className='add-only' value='Complaints_2' /> None
                    <textarea id='txtAdditionalComplaints' name='txtAdditionalComplaints' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Individual experiences the following:</span>
                    <input type="radio" id="rbGlasses_3_Yes" name="rbGlasses_3" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_3_No" name="rbGlasses_3" className='add-only' value="0" />  Yes (describe below):
                    <textarea id='txtAdditionalComplain' name='txtAdditionalComplain' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1' name='cbEating_1' className='add-only' value='Eating_1' /> Eating More
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_2' name='cbEating_2' className='add-only' value='Eating_2' /> Eating Less
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_3' name='cbEating_3' className='add-only' value='Eating_3' /> Not Eating
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_4' name='cbEating_4' className='add-only' value='Eating_4' /> Drinking More
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_5' name='cbEating_5' className='add-only' value='Eating_5' /> Drinking Less
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_6' name='cbEating_6' className='add-only' value='Eating_6' /> Only taking in liquids
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_7' name='cbEating_7' className='add-only' value='Eating_7' /> Increased Appetite
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_8' name='cbEating_8' className='add-only' value='Eating_8' /> Decreased Appetite
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_9' name='cbEating_9' className='add-only' value='Eating_9' /> Nausea
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_10' name='cbEating_10' className='add-only' value='Eating_10' /> Vomiting
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_11' name='cbEating_11' className='add-only' value='Eating_11' /> Trouble Chewing or swallowing
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_12' name='cbEating_12' className='add-only' value='Eating_12' /> Other:
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtVomiting' name='txtVomiting' className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Number of Meals Per Day: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_4_1" name="rb_4" className='add-only' value="1" /> 0
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_4_2" name="rb_4" className='add-only' value="2" /> 1
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_4_3" name="rb_4" className='add-only' value="3" /> 2
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_4_4" name="rb_4" className='add-only' value="4" /> 3
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_4_5" name="rb_4" className='add-only' value="5" /> Other:
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtOtherMeals' name='txtOtherMeals' className='add-only' />
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Number of fast-food meals per week: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_5_1" name="rb_5" className='add-only' value="1" /> 0
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_5_2" name="rb_5" className='add-only' value="2" /> 1-2
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_5_3" name="rb_5" className='add-only' value="3" /> 3-4
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rb_5_4" name="rb_5" className='add-only' value="4" /> 5 or more
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rb_5_5" name="rb_5" className='add-only' value="5" /> Other:
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtOtherMealsFood' name='txtOtherMealsFood' className='add-only' />
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-100'>
                            &nbsp;
                        </td>
                        <td className='w-350'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List significant weight loss/gain:</span>
                    <input type="radio" id="rbGlasses_4_Yes" name="rbGlasses_4" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_4_No" name="rbGlasses_4" className='add-only' value="0" />  Yes (describe below):
                    <textarea id='txtAdditionalComplainWeight_1' name='txtAdditionalComplainWeight_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual have an eating disorder?</span>
                    <input type="radio" id="rbGlasses_5_Yes" name="rbGlasses_5" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_5_No" name="rbGlasses_5" className='add-only' value="0" />  Yes (describe below):
                    <textarea id='txtAdditionalComplainWeight_2' name='txtAdditionalComplainWeight_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual on a medically prescribed diet?</span>
                    <input type="radio" id="rbGlasses_6_Yes" name="rbGlasses_6" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_6_No" name="rbGlasses_6" className='add-only' value="0" />  Yes (describe below):
                    <textarea id='txtAdditionalComplainWeight_3' name='txtAdditionalComplainWeight_3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_1' name='cbEating_1_1' className='add-only' value='Eating_1_1' /> Low Fat
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_2' name='cbEating_1_2' className='add-only' value='Eating_1_2' /> Carbohydrate counting
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_3' name='cbEating_1_3' className='add-only' value='Eating_1_3' /> Low Sugar
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_10' name='cbEating_1_10' className='add-only' value='Eating_1_10' /> Low-carb
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_11' name='cbEating_1_11' className='add-only' value='Eating_1_11' /> High protein
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1_12' name='cbEating_1_12' className='add-only' value='Eating_1_12' /> Other:
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtVomitingOther' name='txtVomitingOther' className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual desire to lose or gain weight?</span>
                    <input type="radio" id="rbGlasses_7_Yes" name="rbGlasses_7" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_7_No" name="rbGlasses_7" className='add-only' value="0" />  Yes (describe below):
                    <textarea id='txtAdditionalComplainWeight_4' name='txtAdditionalComplainWeight_4' className='add-only'></textarea>
                </p>
                <h4>
                    Sexual Behavior
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual sexually active? </span>
                    <input type="radio" id="rbGlasses_8_Yes" name="rbGlasses_8" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_8_No" name="rbGlasses_8" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual use protection during sex?
                    </span>  <span className='small'>(Vaginal Dam, Condoms/Latex Condoms,Latex condom with spermicidal (jelly, foam, cream), IUD, Depo shot, oral birth control, etc.)</span>
                    <input type="radio" id="rbGlasses_9_Yes" name="rbGlasses_9" className='add-only' value="1" /> Denied           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_9_No" name="rbGlasses_9" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the individual ever been tested for HIV? </span>
                    <input type="radio" id="rbGlasses_10_Yes" name="rbGlasses_10" className='add-only' value="1" /> No           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_10_No" name="rbGlasses_10" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual wish to be tested for HIV?</span>
                    <input type="radio" id="rbGlasses_11_Yes" name="rbGlasses_11" className='add-only' value="1" /> No           &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_11_No" name="rbGlasses_11" className='add-only' value="0" />  Yes
                </p>
                <p>
                    <strong> For Women Only:</strong> Questions about menstruation, pregnancy, and childbirth.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Which best describes your menstrual periods?  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbMenstrual_1' name='rbMenstrual_1' className='add-only' value='Menstrual_1' /> Periods are unchanged
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbMenstrual_2' name='rbMenstrual_2' className='add-only' value='Menstrual_2' /> No periods because pregnant or recently gave birth
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbMenstrual_3' name='rbMenstrual_3' className='add-only' value='Menstrual_3' /> Periods have become irregular or changed in frequency, duration, or amount
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbMenstrual_4' name='rbMenstrual_4' className='add-only' value='Menstrual_4' /> No periods for at least a year
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbMenstrual_5' name='rbMenstrual_5' className='add-only' value='Menstrual_5' /> Having periods because taking hormone replacement (estrogen) therapy or oral contraceptives
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>During the week before your period starts, do you have a serious problem with your mood-like depression, anxiety, irritability, anger, or mood swings? </span>
                    <input type="radio" id="rbGlasses_12_Yes" name="rbGlasses_12" className='add-only' value="1" /> No (or does not apply) &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_12_No" name="rbGlasses_12" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, do these problems go away by the end of your period?   </span>
                    <input type="radio" id="rbGlasses_13_Yes" name="rbGlasses_13" className='add-only' value="1" /> Yes &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_13_No" name="rbGlasses_13" className='add-only' value="0" />  No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Date of last menstruation: </span>
                    <input type='date' id='txtDateLastMenstruation' name='txtDateLastMenstruation' className='add-only' />
                    <input type='checkbox' id='rbDateLastMenstruation_1' name='rbDateLastMenstruation_1' className='add-only' value='DateLastMenstruation_1' /> (N/A) Never menstruated
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual pregnant? </span>
                    <input type="radio" id="rbGlasses_14_Yes" name="rbGlasses_14" className='add-only' value="1" /> Denied   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_14_No" name="rbGlasses_14" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Due date:  </span>
                    <input type='date' id='txtDueDate' name='txtDueDate' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you given birth within the last 6 months?  </span>
                    <input type="radio" id="rbGlasses_15_Yes" name="rbGlasses_15" className='add-only' value="1" /> No (or does not apply)   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_15_No" name="rbGlasses_15" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you had a miscarriage within the last 6 months?  </span>
                    <input type="radio" id="rbGlasses_16_Yes" name="rbGlasses_16" className='add-only' value="1" /> No (or does not apply)   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_16_No" name="rbGlasses_16" className='add-only' value="0" />  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you having difficulty getting pregnant?   </span>
                    <input type="radio" id="rbGlasses_17_Yes" name="rbGlasses_17" className='add-only' value="1" /> No (or does not apply)   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_17_No" name="rbGlasses_17" className='add-only' value="0" />  Yes
                </p>
                <h4>
                    Recent Mood Changes
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any recent mood changes:</span>
                    <textarea id='txtMoodChanges_1' name='txtMoodChanges_1' className='add-only'></textarea>
                </p>
                <h4>
                    Sleep Patterns
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>List any sleep problems the individual has been experiencing:</span>
                    <textarea id='txtMoodChanges_2' name='txtMoodChanges_2' className='add-only'></textarea>
                </p>
                <h4>
                    Functional Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual able to perform age-appropriate activities of daily living independently?</span>
                    <input type="radio" id="rbGlasses_18_Yes" name="rbGlasses_18" className='add-only' value="1" /> Yes &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_18_No" name="rbGlasses_18" className='add-only' value="0" />  No (describe below):
                    <textarea id='txtMoodChanges_31' name='txtMoodChanges_31' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual's physical health negatively impact other activities?</span>
                    <input type="radio" id="rbGlasses_19_Yes" name="rbGlasses_19" className='add-only' value="1" /> Yes &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_19_No" name="rbGlasses_19" className='add-only' value="0" />  No (describe below):
                    <textarea id='txtMoodChanges_4' name='txtMoodChanges_4' className='add-only'></textarea>
                </p>
                <h4>
                    Hygiene
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's hygiene:</span>
                    <textarea id='txtMoodChanges_3' name='txtMoodChanges_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>The individual has problems with enuresis and/or encopresis? </span>
                    <input type="radio" id="rbGlasses_20_Yes" name="rbGlasses_20" className='add-only' value="1" /> Denied   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_20_No" name="rbGlasses_20" className='add-only' value="0" />  No (describe below):
                    <textarea id='txtMoodChanges_5' name='txtMoodChanges_5' className='add-only'></textarea>
                </p>
                <h4>
                    Pain Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual currently complaining of pain? </span>
                    <input type="radio" id="rbGlasses_21_Yes" name="rbGlasses_21" className='add-only' value="1" /> Denied   &nbsp; &nbsp;
                    <input type="radio" id="rbGlasses_21_No" name="rbGlasses_21" className='add-only' value="0" /> Yes (describe below):
                    <textarea id='txtMoodChanges_6' name='txtMoodChanges_6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If so, give pain rating:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_1" name="rbRating" className='add-only' value="1" /> 0
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_2" name="rbRating" className='add-only' value="2" /> 1
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_3" name="rbRating" className='add-only' value="3" /> 2
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_4" name="rbRating" className='add-only' value="4" /> 3
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_5" name="rbRating" className='add-only' value="5" /> 4
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_6" name="rbRating" className='add-only' value="6" /> 5
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_7" name="rbRating" className='add-only' value="7" /> 6
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_8" name="rbRating" className='add-only' value="8" /> 7
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_9" name="rbRating" className='add-only' value="9" /> 8
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_10" name="rbRating" className='add-only' value="10" /> 9
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRating_11" name="rbRating" className='add-only' value="" /> 10
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If the individual has pain that interferes with daily lifestyle, please explain below:</span>
                    <textarea id='txtLifestyle' name='txtLifestyle' className='add-only'></textarea>
                </p>
                <h4>
                    Vital Signs
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Vital Signs:</span>
                    <input type='checkbox' id='cbVitalSigns' name='cbVitalSigns' className='add-only' value='VitalSigns' /> Not taken due to telehealth session
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>BP: </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Pulse:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Respiration:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Temp:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Height:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtBp' name='txtBp' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtPulse' name='txtPulse' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtRespiration' name='txtRespiration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtTemp' name='txtTemp' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtHeight' name='txtHeight' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Weight: </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>BMI:</span>
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtWeight' name='txtWeight' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtBmi' name='txtBmi' className='add-only' />
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Abnormal Involuntary Movement Scale (AIMS)</span>
                    <span className='small'>(Required ONLYfor clients on anti-psychotic medications)</span>
                    <input type='checkbox' id='cbAbnormal' name='cbAbnormal' className='add-only' value='Abnormal' /> Not applicable
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <strong>
                                Movement Ratings:</strong> Rate highest severity observed. Rate movements that occur upon activation one less than those observed spontaneously. Select movement as well as code number that applies.
                        </td>
                    </tr>
                    <tr> <td className='w-450'><span className='eleHeader'> Facial and Oral Movements </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td> </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                1. Muscles of Facial Expression</strong> (i.e., movements of forehead, eyebrows, periorbital area, cheeks, including frowning, blinking, smiling, grimacing)
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles1_1" name="rbMuscles1" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles1_2" name="rbMuscles1" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles1_3" name="rbMuscles1" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles1_4" name="rbMuscles1" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles1_5" name="rbMuscles1" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                2. Lips and Perioral Area</strong> (i.e., puckering, pouting, smacking)
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles2_1" name="rbMuscles2" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles2_2" name="rbMuscles2" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles2_3" name="rbMuscles2" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles2_4" name="rbMuscles2" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles2_5" name="rbMuscles2" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                3. Jaw</strong> (i.e., biting, clenching, chewing, mouth opening, lateral movement)
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles3_1" name="rbMuscles3" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles3_2" name="rbMuscles3" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles3_3" name="rbMuscles3" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles3_4" name="rbMuscles3" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles3_5" name="rbMuscles3" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                4. Tongue</strong>  (i.e., Rate only increases in movement both in and out of mouth. NOT inability or sustain movement.)
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles4_1" name="rbMuscles4" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles4_2" name="rbMuscles4" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles4_3" name="rbMuscles4" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles4_4" name="rbMuscles4" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles4_5" name="rbMuscles4" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Extremity Movements </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                5. Upper</strong> (arms, wrists, hands, fingers) Include chroreic movements (i.e., rapid, objectively purposeless, irregular, spontaneous) athetoid movements. DO NOT INCLUDE TREMOR.
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles5_1" name="rbMuscles5" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles5_2" name="rbMuscles5" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles5_3" name="rbMuscles5" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles5_4" name="rbMuscles5" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles5_5" name="rbMuscles5" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                6. Lower </strong>(legs, knees, ankles, toes) i.e., lateral knee movement, foot tapping, heel dropping, foot squirming, inversion and eversion of foot.
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles6_1" name="rbMuscles6" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles6_2" name="rbMuscles6" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles6_3" name="rbMuscles6" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles6_4" name="rbMuscles6" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles6_5" name="rbMuscles6" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Trunk Movements </span></td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                7. Neck, shoulders, hips</strong> (i.e., rocking, twisting, squirming, pelvic gyrations)
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles7_1" name="rbMuscles7" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles7_2" name="rbMuscles7" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles7_3" name="rbMuscles7" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles7_4" name="rbMuscles7" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles7_5" name="rbMuscles7" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Global Judgments </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                8. Severity of abnormal movements overall</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles8_1" name="rbMuscles8" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles8_2" name="rbMuscles8" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles8_3" name="rbMuscles8" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles8_4" name="rbMuscles8" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles8_5" name="rbMuscles8" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                9. Incapacitation due to abnormal movements</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles9_1" name="rbMuscles9" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles9_2" name="rbMuscles9" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles9_3" name="rbMuscles9" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles9_4" name="rbMuscles9" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles9_5" name="rbMuscles9" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                10. Individual's awareness of abnormal movements.<br /></strong> Rate only individual's report.<br />
                            <input type="radio" id="rbAwareness_1" name="rbAwareness" className='add-only' value="1" /> No awareness = 0
                            &nbsp;
                            <input type="radio" id="rbAwareness_2" name="rbAwareness" className='add-only' value="2" /> Aware, no distress = 1
                            <br />
                            <input type="radio" id="rbAwareness_3" name="rbAwareness" className='add-only' value="3" /> Aware, mild distress = 2
                            &nbsp;
                            <input type="radio" id="rbAwareness_4" name="rbAwareness" className='add-only' value="4" /> Aware, moderate distress = 3
                            <br />
                            <input type="radio" id="rbAwareness_5" name="rbAwareness" className='add-only' value="5" /> Aware, severe distress = 4
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles10_1" name="rbMuscles10" className='add-only' value="1" /> 0 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles10_2" name="rbMuscles10" className='add-only' value="2" /> 1 &nbsp;&nbsp; &nbsp;
                            <input type="radio" id="rbMuscles10_3" name="rbMuscles10" className='add-only' value="3" /> 2 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles10_4" name="rbMuscles10" className='add-only' value="4" /> 3 &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles10_5" name="rbMuscles10" className='add-only' value="5" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Dental Status </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                11. Current problems with teeth and/or dentures</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles11_1" name="rbMuscles11" className='add-only' value="1" /> No &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles11_2" name="rbMuscles11" className='add-only' value="2" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                12. Are dentures usually worn?</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles12_1" name="rbMuscles12" className='add-only' value="1" /> No &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles12_2" name="rbMuscles12" className='add-only' value="2" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                13. Edentia?</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles13_1" name="rbMuscles13" className='add-only' value="1" /> No &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles13_2" name="rbMuscles13" className='add-only' value="2" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <strong>
                                14. Do movements disappear in sleep?</strong>
                        </td>
                        <td className='w-300'>
                            <input type="radio" id="rbMuscles14_1" name="rbMuscles14" className='add-only' value="1" /> No &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbMuscles14_2" name="rbMuscles14" className='add-only' value="2" /> Yes
                        </td>
                    </tr>

                </table>



                <table>
                </table>



                <h4>
                    Mental Status Exam
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_1' name='cbAppearance_1_1' className='add-only' value='Appearance_1_1' /> Well groomed
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_2' name='cbAppearance_1_2' className='add-only' value='Appearance_1_2' /> Casual
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_3' name='cbAppearance_1_3' className='add-only' value='Appearance_1_3' /> Disheveled
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_4' name='cbAppearance_1_4' className='add-only' value='Appearance_1_4' /> Unkempt
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_5' name='cbAppearance_1_5' className='add-only' value='Appearance_1_5' /> Bizarre
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_6' name='cbAppearance_1_6' className='add-only' value='Appearance_1_6' /> Inappropriate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1_7' name='cbAppearance_1_7' className='add-only' value='Appearance_1_7' /> Malodorous
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbAppearance_1_8' name='cbAppearance_1_8' className='add-only' value='Appearance_1_8' /> Physical Impairment
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Build</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_1' name='cbBuild_1_1' className='add-only' value='Build_1_1' /> Average Build
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_2' name='cbBuild_1_2' className='add-only' value='Build_1_2' /> Thin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_3' name='cbBuild_1_3' className='add-only' value='Build_1_3' /> Overweight
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_4' name='cbBuild_1_4' className='add-only' value='Build_1_4' /> Obese
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_5' name='cbBuild_1_5' className='add-only' value='Build_1_5' /> Average height
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_6' name='cbBuild_1_6' className='add-only' value='Build_1_6' /> Tall
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBuild_1_7' name='cbBuild_1_7' className='add-only' value='Build_1_7' /> Short
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Demeanor</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_1' name='cbDemeanor_1_1' className='add-only' value='Demeanor_1_1' /> Cooperative
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_2' name='cbDemeanor_1_2' className='add-only' value='Demeanor_1_2' /> Hostile
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_3' name='cbDemeanor_1_3' className='add-only' value='Demeanor_1_3' /> Guarded
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_4' name='cbDemeanor_1_4' className='add-only' value='Demeanor_1_4' /> Withdrawn
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_5' name='cbDemeanor_1_5' className='add-only' value='Demeanor_1_5' /> Preoccupied
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_6' name='cbDemeanor_1_6' className='add-only' value='Demeanor_1_6' /> Demanding
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDemeanor_1_7' name='cbDemeanor_1_7' className='add-only' value='Demeanor_1_7' /> Seductive
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_1' name='cbAffect_1_1' className='add-only' value='Affect_1_1' /> Normal
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_2' name='cbAffect_1_2' className='add-only' value='Affect_1_2' /> Labile
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_3' name='cbAffect_1_3' className='add-only' value='Affect_1_3' /> Flat
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_4' name='cbAffect_1_4' className='add-only' value='Affect_1_4' /> Worrisome
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_5' name='cbAffect_1_5' className='add-only' value='Affect_1_5' /> Sad
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1_6' name='cbAffect_1_6' className='add-only' value='Affect_1_6' /> Apathetic
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_1' name='cbMood_1_1' className='add-only' value='Mood_1_1' /> Appropriate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_2' name='cbMood_1_2' className='add-only' value='Mood_1_2' /> Depressed
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_3' name='cbMood_1_3' className='add-only' value='Mood_1_3' /> Anxious
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_4' name='cbMood_1_4' className='add-only' value='Mood_1_4' /> Euphoric
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_5' name='cbMood_1_5' className='add-only' value='Mood_1_5' /> Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_6' name='cbMood_1_6' className='add-only' value='Mood_1_6' /> Dysphoric
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_7' name='cbMood_1_7' className='add-only' value='Mood_1_7' /> Angry
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1_8' name='cbMood_1_8' className='add-only' value='Mood_1_8' /> Euthymic
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_1' name='cbBehavior_1_1' className='add-only' value='Behavior_1_1' /> Appropriate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_2' name='cbBehavior_1_2' className='add-only' value='Behavior_1_2' /> Hyperactive
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_3' name='cbBehavior_1_3' className='add-only' value='Behavior_1_3' /> Hypoactive
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_4' name='cbBehavior_1_4' className='add-only' value='Behavior_1_4' /> Restless
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_5' name='cbBehavior_1_5' className='add-only' value='Behavior_1_5' /> Relaxed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbBehavior_1_6' name='cbBehavior_1_6' className='add-only' value='Behavior_1_6' /> Other:
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtTimeInOther' name='txtTimeInOther' className='add-only' />
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eye Contact</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbEye_1_1' name='cbEye_1_1' className='add-only' value='Eye_1_1' /> Average
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbEye_1_2' name='cbEye_1_2' className='add-only' value='Eye_1_2' /> Decreased
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbEye_1_3' name='cbEye_1_3' className='add-only' value='Eye_1_3' /> Increased
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_1' name='cbSpeech_1_1' className='add-only' value='Speech_1_1' /> Clear
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_2' name='cbSpeech_1_2' className='add-only' value='Speech_1_2' /> Slurred
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_3' name='cbSpeech_1_3' className='add-only' value='Speech_1_3' /> Rapid
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_4' name='cbSpeech_1_4' className='add-only' value='Speech_1_4' /> Slow
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_5' name='cbSpeech_1_5' className='add-only' value='Speech_1_5' /> Pressured
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_6' name='cbSpeech_1_6' className='add-only' value='Speech_1_6' /> Soft
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_7' name='cbSpeech_1_7' className='add-only' value='Speech_1_7' /> Loud
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1_8' name='cbSpeech_1_8' className='add-only' value='Speech_1_8' /> Monotone
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Process</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_1' name='cbThought_1_1' className='add-only' value='Thought_1_1' /> Logical
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_2' name='cbThought_1_2' className='add-only' value='Thought_1_2' /> Coherent
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_3' name='cbThought_1_3' className='add-only' value='Thought_1_3' /> Tight
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_4' name='cbThought_1_4' className='add-only' value='Thought_1_4' /> Linear
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_5' name='cbThought_1_5' className='add-only' value='Thought_1_5' /> Disorganized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_6' name='cbThought_1_6' className='add-only' value='Thought_1_6' /> Flight of Ideas
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbThought_1_7' name='cbThought_1_7' className='add-only' value='Thought_1_7' /> Loose Associations
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThought_1_8' name='cbThought_1_8' className='add-only' value='Thought_1_8' /> Word Salad
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_1' name='cbThoughtContent_1_1' className='add-only' value='ThoughtContent_1_1' /> Within Normal Limits
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_2' name='cbThoughtContent_1_2' className='add-only' value='ThoughtContent_1_2' /> Hallucinations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_3' name='cbThoughtContent_1_3' className='add-only' value='ThoughtContent_1_3' /> Delusions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_4' name='cbThoughtContent_1_4' className='add-only' value='ThoughtContent_1_4' /> Persecution Ideas
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_5' name='cbThoughtContent_1_5' className='add-only' value='ThoughtContent_1_5' /> Suicidal Ideation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_6' name='cbThoughtContent_1_6' className='add-only' value='ThoughtContent_1_6' /> Homicidal Ideation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_7' name='cbThoughtContent_1_7' className='add-only' value='ThoughtContent_1_7' /> Derealization
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_8' name='cbThoughtContent_1_8' className='add-only' value='ThoughtContent_1_8' /> Depersonalization
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_9' name='cbThoughtContent_1_9' className='add-only' value='ThoughtContent_1_9' /> Ideas of Reference
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_10' name='cbThoughtContent_1_10' className='add-only' value='ThoughtContent_1_10' /> Preoccupations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_11' name='cbThoughtContent_1_11' className='add-only' value='ThoughtContent_1_11' /> Strange Experiences
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThoughtContent_1_12' name='cbThoughtContent_1_12' className='add-only' value='ThoughtContent_1_12' /> Obsessions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight</span>
                        </td></tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbInsight_1_1' name='cbInsight_1_1' className='add-only' value='Insight_1_1' /> Age Appropriate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbInsight_1_2' name='cbInsight_1_2' className='add-only' value='Insight_1_2' /> Limited
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbInsight_1_3' name='cbInsight_1_3' className='add-only' value='Insight_1_3' /> Poor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbInsight_1_4' name='cbInsight_1_4' className='add-only' value='Insight_1_4' /> Unclear
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbJudgment_1_1' name='cbJudgment_1_1' className='add-only' value='Judgment_1_1' /> Age Appropriate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbJudgment_1_2' name='cbJudgment_1_2' className='add-only' value='Judgment_1_2' /> Limited
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbJudgment_1_3' name='cbJudgment_1_3' className='add-only' value='Judgment_1_3' /> Poor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbJudgment_1_4' name='cbJudgment_1_4' className='add-only' value='Judgment_1_4' /> Unclear
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMemory_1_1' name='cbMemory_1_1' className='add-only' value='Memory_1_1' /> Intact
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMemory_1_2' name='cbMemory_1_2' className='add-only' value='Memory_1_2' /> Recent Intact
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMemory_1_3' name='cbMemory_1_3' className='add-only' value='Memory_1_3' /> Remote intact
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOrientation_1_1' name='cbOrientation_1_1' className='add-only' value='Orientation_1_1' /> Person
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOrientation_1_2' name='cbOrientation_1_2' className='add-only' value='Orientation_1_2' /> Place
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOrientation_1_3' name='cbOrientation_1_3' className='add-only' value='Orientation_1_3' /> Time
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOrientation_1_4' name='cbOrientation_1_4' className='add-only' value='Orientation_1_4' /> Situation
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motivation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMotivation_1_1' name='cbMotivation_1_1' className='add-only' value='Motivation_1_1' /> Good
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMotivation_1_2' name='cbMotivation_1_2' className='add-only' value='Motivation_1_2' /> Fair
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMotivation_1_3' name='cbMotivation_1_3' className='add-only' value='Motivation_1_3' /> Poor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMotivation_1_4' name='cbMotivation_1_4' className='add-only' value='Motivation_1_4' /> Unclear
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments regarding any items of concerns above outside of normal limits: </span>
                    <textarea id='txComments_1' name='txComments_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary </span>
                    <textarea id='txComments_2' name='txComments_2' className='add-only'></textarea>
                </p>
                <h4>
                    Recommendations/Plan
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Service Recommendations:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbService_1' name='cbService_1' className='add-only' value='Service_1' />  (C&A CORE) Individual/family therapy services 1-4 x monthly, CSI 2-8 x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbService_2' name='cbService_2' className='add-only' value='Service_2' />  (C&A IFI) IFI services 3-8 x weekly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbService_3' name='cbService_3' className='add-only' value='Service_3' />  (Adult CORE) Individual/family therapy services 1-4 x monthly, PSR-I 2-8 x monthly, case management 2-8x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbService_4' name='cbService_4' className='add-only' value='Service_4' />  Other:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtTimeOther4' name='txtTimeOther4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Labs Requested Today?: </span>
                    <input type="radio" id="rbLabs_Yes" name="rbLabs" className='add-only' value="1" /> No   &nbsp; &nbsp;
                    <input type="radio" id="rbLabs_No" name="rbLabs" className='add-only' value="0" />  Yes:
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Referrals Provided: </span>
                    <input type="radio" id="rbLabs_2_Yes" name="rbLabs_2" className='add-only' value="1" /> No   &nbsp; &nbsp;
                    <input type="radio" id="rbLabs_2_No" name="rbLabs_2" className='add-only' value="0" />  Yes, please list:
                    <textarea id='txtLabs' name='txtLabs' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Additional Recommendations:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_1' name='cbRecommendations_1' className='add-only' value='Recommendations_1' />  None
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_2' name='cbRecommendations_2' className='add-only' value='Recommendations_2' />  Medical Follow up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_3' name='cbRecommendations_3' className='add-only' value='Recommendations_3' />  Referral to primary care physician
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_4' name='cbRecommendations_4' className='add-only' value='Recommendations_4' />  Fitness and NutritionEducation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_5' name='cbRecommendations_5' className='add-only' value='Recommendations_5' />  Health Education
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_6' name='cbRecommendations_6' className='add-only' value='Recommendations_6' />  Medication Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_7' name='cbRecommendations_7' className='add-only' value='Recommendations_7' />  Chronic DiseaseEducation/Training
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_8' name='cbRecommendations_8' className='add-only' value='Recommendations_8' />  Substance Abuse/Relapse Prevention Training
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_9' name='cbRecommendations_9' className='add-only' value='Recommendations_9' />  Smoking Cessation Training/Classes
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRecommendations_10' name='cbRecommendations_10' className='add-only' value='Recommendations_10' />  Other:
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtRecommendations' name='txtRecommendations' className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Follow up:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbFollow_1" name="rbFollow" className='add-only' value="1" /> 4-8 weeks
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbFollow_2" name="rbFollow" className='add-only' value="2" /> 8-12 weeks
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbFollow_3" name="rbFollow" className='add-only' value="3" /> Annually/as needed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbFollow_4" name="rbFollow" className='add-only' value="4" /> Other:
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTimOther' name='txtTimOther' className='add-only' />
                        </td> 
                    </tr>
                </table>
                {/* <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Nurse Signature/Credentials:	 </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Nurse Name/Credentials (Print): </td>
                        <td className='small w-375'> Date: </td>
                    </tr>
                </table> */}



            </div>
        </form>

    )
}